import {
  commonAuthenticatedHeaders,
  commonUnauthenticatedHeaders,
  commonUnauthenticatedABDMHeaders
  // commonAuthenticatedABDMHeaders
} from "../constants/headers";
import history from "./history";
import { toast } from "react-toastify";
import { msalInstance } from "../index";
import { loginRequest } from "../authConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { t } from "i18next";
import { T_GENERAL, T_LOGIN } from "../constants/translations";

export async function getAuthenticatedImage(url = "") {
  if (sessionStorage.getItem("ad")) {
    try {
      let accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: JSON.parse(sessionStorage.getItem("account"))
      });
      sessionStorage.setItem("bearerToken", accessTokenResponse.accessToken);
      return fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
          ...commonAuthenticatedHeaders()
        }
      })
        .catch(e => {
          toast.error(t(T_GENERAL.somethingWentWrong));
          throw e;
        })
        .then(response => {
          if (response.status === 401 || response.status === 403) {
            logOutUser();
          }
          return response.blob();
        })
        .then(response => {
          return response;
        });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account: JSON.parse(sessionStorage.getItem("account"))
        });
      }
    }
  } else {
    return fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        ...commonAuthenticatedHeaders()
      }
    })
      .catch(e => {
        toast.error(t(T_GENERAL.somethingWentWrong));
        throw e;
      })
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          logOutUser();
        }
        return response.blob();
      })
      .then(response => {
        return response;
      });
  }
}

// `opts.silent`: best-effort callers (e.g. ExamData's device-inventory lookup)
// pass this so a failed request never surfaces the global "Something went
// wrong" toast — the caller handles the rejection and falls back itself.
// Regional backends that predate an endpoint answer 500 without CORS headers,
// which the browser reports as a network error and would otherwise toast on
// every page load.
export async function getAuthenticatedData(url = "", opts = {}) {
  const silent = Boolean(opts && opts.silent);
  if (sessionStorage.getItem("ad")) {
    try {
      let accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: JSON.parse(sessionStorage.getItem("account"))
      });
      sessionStorage.setItem("bearerToken", accessTokenResponse.accessToken);
      return fetch(url, {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
          ...commonAuthenticatedHeaders()
        }
      })
        .catch(e => {
          if (!silent) toast.error(t(T_GENERAL.somethingWentWrong));
          throw e;
        })
        .then(response => {
          if (response.status === 401 || response.status === 403) {
            logOutUser();
          }
          return response.json();
        })
        .then(response => {
          return response;
        });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account: JSON.parse(sessionStorage.getItem("account"))
        });
      }
    }
  } else {
    return fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        ...commonAuthenticatedHeaders()
      }
    })
      .catch(e => {
        if (!silent) toast.error(t(T_GENERAL.somethingWentWrong));
        throw e;
      })
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          logOutUser();
        }
        return response.json();
      })
      .then(response => {
        return response;
      });
  }
}

export async function deleteAuthenticatedData(url = "", data = {}) {
  if (sessionStorage.getItem("ad")) {
    try {
      let accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: JSON.parse(sessionStorage.getItem("account"))
      });
      sessionStorage.setItem("bearerToken", accessTokenResponse.accessToken);
      return fetch(url, {
        method: "DELETE", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
          ...commonAuthenticatedHeaders()
        },
        body: JSON.stringify(data)
      })
        .catch(e => {
          toast.error(t(T_GENERAL.somethingWentWrong));
          throw e;
        })
        .then(response => {
          if (response.status === 401 || response.status === 403) {
            logOutUser();
          }
          return response;
        });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account: JSON.parse(sessionStorage.getItem("account"))
        });
      }
    }
  } else {
    return fetch(url, {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        ...commonAuthenticatedHeaders()
      },
      body: JSON.stringify(data)
    })
      .catch(e => {
        toast.error(t(T_GENERAL.somethingWentWrong));
        throw e;
      })
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          logOutUser();
        }
        return response;
      });
  }
}

export function getUnauthenticatedData(url = "") {
  return fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
      ...commonUnauthenticatedHeaders()
    }
  })
    .catch(e => {
      toast.error(t(T_GENERAL.somethingWentWrong));
      throw e;
    })
    .then(response => {
      return response;
    });
}

export async function postAuthenticatedFormData(url = "", data = {}) {
  if (sessionStorage.getItem("ad")) {
    try {
      let accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: JSON.parse(sessionStorage.getItem("account"))
      });
      sessionStorage.setItem("bearerToken", accessTokenResponse.accessToken);
      return fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        headers: {
          ...commonAuthenticatedHeaders()
        },
        body: data
      })
        .catch(e => {
          toast.error(t(T_GENERAL.somethingWentWrong));
          throw e;
        })
        .then(response => {
          if (response.status === 401 || response.status === 403) {
            logOutUser();
          }
          return response;
        });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account: JSON.parse(sessionStorage.getItem("account"))
        });
      }
    }
  } else {
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      headers: {
        ...commonAuthenticatedHeaders()
      },
      body: data
    })
      .catch(e => {
        toast.error(t(T_GENERAL.somethingWentWrong));
        throw e;
      })
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          logOutUser();
        }
        return response;
      });
  }
}

export async function postAuthenticatedData(url = "", data = {}) {
  if (sessionStorage.getItem("ad")) {
    try {
      let accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: JSON.parse(sessionStorage.getItem("account"))
      });
      sessionStorage.setItem("bearerToken", accessTokenResponse.accessToken);
      return fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
          ...commonAuthenticatedHeaders()
        },
        body: JSON.stringify(data)
      })
        .catch(e => {
          toast.error(t(T_GENERAL.somethingWentWrong));
          throw e;
        })
        .then(response => {
          if (response.status === 401 || response.status === 403) {
            logOutUser();
          }
          return response;
        });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account: JSON.parse(sessionStorage.getItem("account"))
        });
      }
    }
  } else {
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        ...commonAuthenticatedHeaders()
      },
      body: JSON.stringify(data)
    })
      .catch(e => {
        toast.error(t(T_GENERAL.somethingWentWrong));
        throw e;
      })
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          logOutUser();
        }
        return response;
      });
  }
}

export async function putAuthenticatedData(url = "", data = {}) {
  if (sessionStorage.getItem("ad")) {
    try {
      let accessTokenResponse = await msalInstance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: JSON.parse(sessionStorage.getItem("account"))
      });
      sessionStorage.setItem("bearerToken", accessTokenResponse.accessToken);
      return fetch(url, {
        method: "PUT", // *GET, POST, PUT, DELETE, etc.
        headers: {
          "Content-Type": "application/json",
          ...commonAuthenticatedHeaders()
        },
        body: JSON.stringify(data) // body data type must match "Content-Type" header
      })
        .catch(e => {
          toast.error(t(T_GENERAL.somethingWentWrong));
          throw e;
        })
        .then(response => {
          if (response.status === 401 || response.status === 403) {
            logOutUser();
          }
          return response;
        });
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect({
          scopes: loginRequest.scopes,
          account: JSON.parse(sessionStorage.getItem("account"))
        });
      }
    }
  } else {
    return fetch(url, {
      method: "PUT", // *GET, POST, PUT, DELETE, etc.
      headers: {
        "Content-Type": "application/json",
        ...commonAuthenticatedHeaders()
      },
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .catch(e => {
        toast.error(t(T_GENERAL.somethingWentWrong));
        throw e;
      })
      .then(response => {
        if (response.status === 401 || response.status === 403) {
          logOutUser();
        }
        return response;
      });
  }
}

export function putUnauthenticatedData(url = "", data = {}, extraHeaders = {}) {
  return fetch(url, {
    method: "PUT", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
      ...commonUnauthenticatedHeaders(),
      ...extraHeaders
    },
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
    .catch(e => {
      toast.error(t(T_GENERAL.somethingWentWrong));
      throw e;
    })
    .then(response => {
      return response;
    });
}

export function postUnauthenticatedData(url = "", data = {}) {
  return fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
      ...commonUnauthenticatedHeaders()
    },
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
    .catch(e => {
      toast.error(t(T_GENERAL.somethingWentWrong));
      throw e;
    })
    .then(response => {
      return response;
    });
}

export function postUnauthenticatedABDMData(url = "", data = {}) {
  return fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
      ...commonUnauthenticatedABDMHeaders()
    },
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
    .catch(e => {
      toast.error(t(T_GENERAL.somethingWentWrong));
      throw e;
    })
    .then(response => {
      return response.json();
    });
}

export async function postAuthenticatedABDMData(
  method = "POST",
  url = "",
  data = {},
  additionalHeaders = {},
  additionalParameters = {}
) {
  return fetch(sessionStorage.getItem("domain") + "/api/abdm/abdmProxyCall", {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    headers: {
      "Content-Type": "application/json",
      ...commonAuthenticatedHeaders()
    },
    body: JSON.stringify({
      requestPath: url,
      ...(method === "POST" && { requestBody: JSON.stringify(data) }),
      httpMethod: method,
      ...(Object.keys(additionalHeaders).length > 0 && { additionalHeaders }),
      ...(Object.keys(additionalParameters).length > 0 && {
        additionalParameters
      })
    })
  })
    .catch(e => {
      toast.error(t(T_GENERAL.somethingWentWrong));
      throw e;
    })
    .then(async response => {
      if (response.status !== 200) {
        // let res = await response.json();
        // toast.error(res.message);
      }
      return response.json();
    });
}

function logOutUser() {
  if (sessionStorage.getItem("bearerToken")) {
    sessionStorage.removeItem("bearerToken");
  }
  if (!sessionStorage.getItem("calledLogoutOnce")) {
    toast.error(t(T_LOGIN.toast.sessionTerminated));
  }
  sessionStorage.clear();
  sessionStorage.setItem("calledLogoutOnce", true);
  history.push("/login");
}
